// Copyright (c) StrangeBee 2023

import React, { ReactElement, useState } from 'react';
import { ICONS } from '@Constants/iconsApp';

import './Icons.scss';

export const IconsViewer = (): ReactElement => {
    const [filter, setFilter] = useState('');

    return (
        <div className="icons-viewer">
            <div className="icons-viewer__header">
                <h1 className="icons-viewer__title">
                    Icons Viewer (
                    <a href="https://fontawesome.com/v6.0/icons/flag?q=flag&s=regular" target="_blank" rel="noreferrer">
                        FontAwesome
                    </a>
                    )
                </h1>
                <input onChange={(e) => setFilter(e.target.value)} />
            </div>
            <div className="icons-viewer__list">
                {Object.entries(ICONS)
                    .filter(([key]) => key.toLocaleLowerCase().includes(filter.toLocaleLowerCase()))
                    .map(([key, IconComponent]) => {
                        return (
                            <div key={key} className="icons-viewer__item">
                                <span className="icons-viewer__item-name">{key}</span>
                                <span className="icons-viewer__item-icon">
                                    <IconComponent />
                                </span>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
